function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "remove");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Invision",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "remove",
  transform: "translate(-0.000772, 0.249228)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.3171775,12.3171774 C12.0729201,12.5614348 11.6777246,12.5614348 11.4331929,12.3171774 L6.25077173,7.13358432 L1.0671781,12.3171774 C0.822920054,12.5614348 0.42772457,12.5614348 0.183193535,12.3171774 C-0.0610645115,12.0729199 -0.0610645115,11.6777244 0.183193535,11.4331928 L5.36795899,6.25077158 L0.183974952,1.06717736 C-0.0602830946,0.822919905 -0.0602830946,0.427724421 0.183974952,0.183193982 C0.428232998,-0.0610646605 0.823428482,-0.0610646605 1.06795952,0.183193982 L6.25077173,5.36795884 L11.434366,0.184365809 C11.6786234,-0.0598928332 12.0738189,-0.0598928332 12.3183505,0.184365809 C12.562608,0.428623259 12.562608,0.823818743 12.3183505,1.06834918 L7.13358447,6.25077158 L12.3171775,11.4343658 C12.563272,11.6765526 12.563272,12.0749906 12.3171775,12.3171774 Z",
  id: "Path"
})));
const SvgIconRemove = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRemove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-remove.ea9ffa93.svg";
export { ForwardRef as ReactComponent };